/*
 * @Descripttion:定义常量，使用常量替代 mutation 事件类型
 * @version:
 * @Author: limin
 * @Date: 2021-03-23 11:13:39
 * @LastEditors: limin
 * @LastEditTime: 2021-04-21 13:40:46
 */
// init 模块
export const SET_SYSTEM_INFO = 'SET_SYSTEM_INFO';
// cart模块
export const CART_GET_CART_PRODUCT_LIST = 'CART_GET_CART_PRODUCT_LIST' // 获取购物车商品列表
export const CART_ADD_PRODUCT_TO_CART = 'CART_ADD_PRODUCT_TO_CART' // 添加购物车
export const CART_DEL_PRODUCT_TO_CART = 'CART_DEL_PRODUCT_TO_CART' // 删除购物车
export const CART_CHANGE_LOGIN_STATUS = 'CART_CHANGE_LOGIN_STATUS'  // 切换登陆状态
export const CART_ADD_PRODUCT_QUANTITY = 'CART_ADD_PRODUCT_QUANTITY'  // 添加商品数量
export const CART_DEL_PRODUCT_QUANTITY = 'CART_DEL_PRODUCT_QUANTITY'  // 减少商品数量
export const CART_SET_CHECKOUT_STATUS_ALL = 'CART_SET_CHECKOUT_STATUS_ALL'   // 一键改变所有商品购买状态的方法
export const CART_SET_CHECKOUT_STATUS = 'CART_SET_CHECKOUT_STATUS'   // 切换一条商品的选中状态的方法


// products模块
export const PRODUCTS_SET_PRODUCT = 'PRODUCTS_SET_PRODUCT' // 获取所有商品的列表
export const PRODUCTS_SET_DETAIL_PRODUCT = 'PRODUCTS_SET_DETAIL_PRODUCT' // 设置当前查看详情的商品
export const PRODUCTS_SET_ALL_LABELS = 'PRODUCTS_GET_ALL_LABELS' // 保存所有标签
export const PRODUCTS_SET_LABELS_INDEX = 'PRODUCTS_SET_LABELS_INDEX' // 保存当前标签索引
export const PRODUCTS_SET_CATEGORYS = 'PRODUCTS_SET_CATEGORYS' // 保存所欲分类
export const PRODUCTS_SET_CATEGORY_ID = 'PRODUCTS_SET_CATEGORY_ID' // 设置当前分类ID(一级)


// address模块
export const ADDRESS_GET_ADDRESS_LIST = 'ADDRESS_GET_ADDRESS_LIST' // 获取所有地址的列表
export const ADDRESS_SET_ACTIVE_ADDRESS = 'ADDRESS_SET_ACTIVE_ADDRESS' // 设置某个地址为active状态
export const ADDRESS_SET_DEFAULT_ADDRESS = 'ADDRESS_SET_DEFAULT_ADDRESS' // 设置某个地址为default状态

// common模块
export const COMMON_SET_TEMP_PARAMS = 'ADDRESS_GET_ADDRESS_LIST' // 设置临时参数
export const COMMON_SET_SYS_CONFIG = 'COMMON_SET_SYS_CONFIG' // 设置系统参数
export const COMMON_SET_IS_SHOW_TABBAR = 'COMMON_SET_IS_SHOW_TABBAR' // 设置显示tabbar状态
export const COMMON_CLEAR_SESSION = 'COMMON_CLEAR_SESSION' // 清空session
export const COMMON_SEARCH_TEXT = 'COMMON_SEARCH_TEXT' // 设置搜索框值
export const COMMON_SET_NAVBAR = 'COMMON_SET_NAVBAR' // 设置NAVBAR

